import Swal from 'sweetalert2'
import { swalOption } from '../components/swal-opt'
import { asyncFetchData } from './fetch-data'
// import { targetNext } from './targetNext'
import detectMobileWidth from './detectMobileWidth'
import { setCookie } from './cookie'
import getUrlSearchParams from './getUrlSearchParams'

function orphanSeatModal(data) {
	const { removeTickets, addTickets } = data.message
	window.orphanSeat = true
	const str = `
				<form id="changeTicketsForm" action="/store/shopping-cart/change-tickets" method="post">
					<div class="">
						<h3>${window.myvars['Attention: Your seat was adjusted']}</h3>
						<div class='text-left'>${window.myvars['Your selection of seats was moved over one seat to minimize isolated single seats.']}</div>

						<input type="hidden" name="removeTickets" value=${removeTickets} />
						<input type="hidden" name="addTickets" value=${addTickets} />
						<input type="hidden" name="salesChannel" value="0">
					</div>
				</form>
			`

	const opt = {
		showDenyButton: true,
		customClass: {
			container: 'swal2Container',
			popup: 'popup-class',
			confirmButton: 'confirm-button-class',
			denyButton: 'swal2-deny__text'
		},
		denyButtonColor: 'transparent',
	}

	Swal.fire(
		(data.status === 2)
			? { ...swalOption(str, true, false), ...opt, denyButtonText: window.myvars['No, please use exact seats I selected.'] }
			: { ...swalOption(str, true, false), ...opt, denyButtonText: window.myvars['No, let me select another seat.'] }
	).then((result) => {
		if (result.isConfirmed) {
			if (window.myvars.onePageCheckout) {
    		window.location.href = '/store/checkout'
				return
			}

			const isMobileWidth = detectMobileWidth()
			setCookie('giftCardCheckout', 0, 1, '')
			if(getUrlSearchParams('mobileOnePage')==='1' && isMobileWidth) {
				window.location.href = `/store/order/fast-payment-one-page/user/${window.myvars.visitUniqueNum}`
			} else if(getUrlSearchParams('mobileOnePage')==='0') {
				window.location.href = '/store/order/review-cart'
			} else if(window.myvars.mobileOnePageCheckout && isMobileWidth) {
				window.location.href = `/store/order/fast-payment-one-page/user/${window.myvars.visitUniqueNum}`
			} else {
				window.location.href = '/store/order/review-cart'
			}
		} else {
			if (data.status === 2) {
				console.log('result', result)
				if(result.isDenied) {
					(document.querySelector('#changeTicketsForm') as HTMLFormElement).submit()
				} else {
					asyncFetchData('/store/shopping-cart/remove-all-clear-patron', { ajax: 1 })
				}
			} else {
				asyncFetchData('/store/shopping-cart/remove-all-clear-patron', { ajax: 1 })
			}
		}
	})
}

export default orphanSeatModal
